module.exports = __webpack_public_path__ + "static/img/main_point_img02.e1d7f5c2.svg";